import { styled } from "goober";

export const panelFrameStyles = `
  background: var(--surface-secondary);
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  overflow: hidden;
`;

export const PanelFrame = styled("div")`
  ${panelFrameStyles}
`;
